/**
 * Merge the Send and PayRequest preview pages
 *
 * Conditions:
 * - Control: User lands on separate preview components for send and payrequest
 * - Treatment: lands on the unified preview page
 */

import * as pxp from '../lib/pxp'

export const UNIFIED_PREVIEW_TREATMENT =
  'Trmt_p2p_unified_send_payrequest_preview'

export function showUnifiedPreview() {
  return pxp.isTreatment(UNIFIED_PREVIEW_TREATMENT)
}
